import Vue from 'vue'
import Vuex from 'vuex'
import layout from './layout-store.js'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        layout: layout
    }
})


// WEBPACK FOOTER //
// ./src/store/store.js